/**
 * The sell-back quote — pure, so it is testable and cannot drift from the server.
 *
 * Goods bought with Shrooms go back at the price paid, minus the sell-back fee.
 * The board sends the whole returnable lot (`refund` for all `units`); a partial
 * sale is priced exactly the way forager.service sellBack() prices it: the gross
 * is floor(refund × qty / units), the fee is that gross × commission, rounded UP
 * (so selling one unit at a time never dodges it).
 */
import type { SellBackRow } from '../../game-api';

export interface SellBackQuote { gross: number; fee: number; net: number }

export function sellBackQuote(row: SellBackRow, qty: number, commission: number): SellBackQuote {
  const n = Math.max(0, Math.min(qty, row.units));
  if (n === 0 || row.units === 0) return { gross: 0, fee: 0, net: 0 };
  const gross = Math.floor((row.refund * n) / row.units);
  // Epsilon: 75 × 0.04 is 3.0000000000000004 in floating point, not 3.
  const fee = Math.min(gross, Math.max(0, Math.ceil(gross * commission - 1e-9)));
  return { gross, fee, net: gross - fee };
}

/** How many of a bag row may be sold for Coins (older servers send no split). */
export function coinSellable(owned: number, coinSellable: number | undefined): number {
  return Math.max(0, Math.min(owned, coinSellable ?? owned));
}
